<template>
  <Form
    ref="form"
    inline
    :model="form"
  >
    <FormItem prop="keyword">
      <Input
        v-model="form.keyword"
        style="width: 320px"
        placeholder="请输入广告主公司名称/帐号/客户编号/产品名"
        clearable
      />
    </FormItem>

    <FormItem prop="last_cost_day">
      <Select
        v-model="form.last_cost_day"
        placeholder="最后一次消耗时间"
        clearable
      >
        <Option
          v-for="item in lastCostDay"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </Select>
    </FormItem>

    <FormItem prop="over_day">
      <Select
        v-model="form.over_day"
        placeholder="释放时间"
        clearable
      >
        <Option
          v-for="item in release"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </Select>
    </FormItem>

    <FormItem prop="order_by">
      <Select
        v-model="form.order_by"
        placeholder="排序"
        clearable
      >
        <Option
          v-for="item in order"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </Select>
    </FormItem>

    <FormItem>
      <Button
        type="primary"
        @click="search"
      >
        查询
      </Button>
      <Button @click="reset">
        重置
      </Button>
    </FormItem>
  </Form>
</template>

<script>
import { Form, FormItem, Input, Select, Option, Button } from 'element-ui';

export default {
  components: {
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Button,
  },

  data() {
    return {
      form: {
        keyword: undefined,
        last_cost_day: undefined,
        over_day: undefined,
        order_by: undefined,
      },
      lastCostDay: [
        {
          value: 1,
          label: '3天内',
        },
        {
          value: 2,
          label: '7天内',
        },
        {
          value: 3,
          label: '30天以上',
        },
        {
          value: 4,
          label: '50天以上',
        },
        {
          value: 5,
          label: '55天以上',
        },
      ],
      release: [
        {
          value: 1,
          label: '3天内即将释放',
        },
        {
          value: 2,
          label: '7天内将释放',
        },
        {
          value: 3,
          label: '大于30天',
        },
      ],
      order: [
        {
          value: 1,
          label: '按最后一次消耗时间倒序排序',
        },
        {
          value: 0,
          label: '按释放时间倒序排序',
        },
        {
          value: 2,
          label: '按归属时间正序排序',
        },
      ],
    };
  },

  methods: {
    search() {
      this.$refs.form.validate((valid) => {
        this.$emit('search', this.form);
      });
    },

    reset() {
      this.$refs.form.resetFields();
      this.$emit('search', this.form);
    },

    getParams() {
      return this.form;
    },
  },
};
</script>